import { Haemoglobin } from "@cur8/health-risks-calc";
import { useQueryParams } from "@pomle/react-router-paths";
import { usePatientQuery } from "render/hooks/api/queries/usePatientQuery";
import { queries } from "render/routes/paths";
import { toChartRanges } from "render/ui/presentation/RangeChart/lib/risk";
import { MetricDetails } from "render/views/Report/AppointmentDataView/components/MetricsSection/components/layouts/Details";
import { getMetricHistory } from "render/views/Report/AppointmentDataView/components/MetricsSection/components/metrics/utils/getMetricHistory";
import { useHaemoglobinMetric } from "render/views/Report/AppointmentDataView/components/MetricsSection/hooks/usePatientReportMetrics";
import { Trans } from "./trans";

export function MetricHaemoglobinDetails() {
  const { data } = useHaemoglobinMetric();
  const { data: patient } = usePatientQuery();
  const [params, setParams] = useQueryParams(queries.metric);

  if (!data || !patient) {
    return null;
  }

  const numOfScans = data.length || 1;
  const scanNum = params.scan[0] || numOfScans;
  const setScanNum = (num: number) =>
    setParams({
      scan: [num],
    });

  const riskRanges = Haemoglobin.rangesFor({ sex: patient.sex });

  const { cur: current, prev: previous } = getMetricHistory(data, scanNum);

  const values = {
    subLabel: <Trans.MetricUnit />,
    value: current?.unit["g/L"],
    previousValue: previous?.unit["g/L"],
    metricRating: current && riskRanges.findRisk(current.unit),
    scanDate: current?.measurement.timestampStart,
    ranges: toChartRanges(riskRanges.entries),
  };

  return (
    <MetricDetails
      label={<Trans.MetricName />}
      values={values}
      scanNum={scanNum}
      setScanNum={setScanNum}
      numOfScans={numOfScans}
      FAQText={Trans.FAQ}
    />
  );
}
